import { CanActivateChildFn, CanActivateFn, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthGuardData, createAuthGuard } from 'keycloak-angular';

const isAccessAllowed = async (
    _route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
    authData: AuthGuardData
): Promise<boolean> =>
{
    const { authenticated, keycloak } = authData;

    if (authenticated)
        return true;

    await keycloak.login({ redirectUri: window.location.origin + state.url });
    return false;
};

export const authGuard = createAuthGuard<CanActivateFn>(isAccessAllowed);
export const authChildGuard = createAuthGuard<CanActivateChildFn>(isAccessAllowed);
